import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { HttpService } from '../../globals/providers/http.service';
import { AppEndpoints } from '../app.endpoints';
import { IFaqSectionsRequest } from '../classes/http-requests';
import { FaqSection, FaqSectionsResponse, IFaqSectionsResponse } from '../classes/http-responses';

export class FAQsService {
      private static readonly loginHelpTageName = 'login_help';

	public static getFaqSections(
		langId: string,
		userType: string
	): Observable<FaqSection[]> {
		const request: IFaqSectionsRequest = {
			tagName: FAQsService.loginHelpTageName,
			langId: langId,
			userType: userType,
		};

		return HttpService.post<IFaqSectionsResponse>(AppEndpoints.faqSections, request).pipe(
			map((response) => {
				var responseAsClass = new FaqSectionsResponse(response);
				return  responseAsClass.faqSections.sort((sectionA, sectionB) => (sectionA.sortOrder > sectionB.sortOrder) ? 1 : -1)
			})
		);
	}
}
